module.exports = __webpack_public_path__ + "static/media/ICN_Druck_small.ce71823e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ICN_Druck_small.svg
// module id = 182
// module chunks = 0